import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
var initialState = {
  conversationChannelId: '',
  experienceId: '',
  product: '',
  productHeader: '',
  agentId: null,
  agentExternalConfigReference: null,
  agentIsDefault: null,
  fullScreen: false,
  agentCreatorType: '',
  agentVisibility: '',
  singleInstrumentationID: ''
};
var AnalyticsPropertiesContext = /*#__PURE__*/createContext({
  propertiesRef: {
    current: _objectSpread({}, initialState)
  },
  setAnalyticsPropertiesWithoutRerender: function setAnalyticsPropertiesWithoutRerender() {}
});

/**
 * This context contains ref to the properties that will be added to `useAnalytics` when firing an event
 * Using `ref` so this context does not rerender when any of the analytics properties change
 * Because the updated attributes are only needed when the analytics is fired
 */
export var AnalyticsPropertiesContextProvider = function AnalyticsPropertiesContextProvider(_ref) {
  var children = _ref.children;
  var propertiesRef = useRef(_objectSpread({}, initialState));
  var setAnalyticsPropertiesWithoutRerender = useCallback(function (properties) {
    propertiesRef.current = _objectSpread(_objectSpread({}, propertiesRef.current), properties);
  }, []);
  var value = useMemo(function () {
    return {
      propertiesRef: propertiesRef,
      setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
    };
  }, [setAnalyticsPropertiesWithoutRerender]);
  return /*#__PURE__*/React.createElement(AnalyticsPropertiesContext.Provider, {
    value: value
  }, children);
};

/**
 * Adding extra wrapper to AnalyticsPropertiesContextProvider
 * for `source` attribute
 * using AnalyticsContext
 */
export var AnalyticsContextWithSourceAndProperties = function AnalyticsContextWithSourceAndProperties(_ref2) {
  var source = _ref2.source,
    children = _ref2.children;
  var data = useMemo(function () {
    return {
      source: source
    };
  }, [source]);
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: data
  }, /*#__PURE__*/React.createElement(AnalyticsPropertiesContextProvider, null, children));
};
export var useAnalyticsPropertiesContext = function useAnalyticsPropertiesContext() {
  return useContext(AnalyticsPropertiesContext);
};